import { useLocation } from "react-router-dom";

export const useQueryParams = (queryParams: string[]): any => {
  const res = {};
  const params = new URLSearchParams(useLocation().search);
  queryParams.forEach((p) => (res[p] = params.get(p)));
  return res;
};
